<template>
  <el-dialog
    title="导出结果"
    :visible="visible"
    :before-close="handleClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="420px"
    custom-class="export-result-dialog"
  >
    <div class="result-content">
      <div v-if="!hasExportData" class="no-data-content">
        <p class="result-text">请先点击“导出”按钮导出数据，</p>
        <p class="result-text">系统仅保留三个月内最近一次导出结果。</p>
      </div>
      
      <div v-else class="data-content">
        <div class="file-info">
          <p class="file-line">
            上次导出数据：{{ exportData.fileName }}
            <a 
              href="javascript:;" 
              class="download-link" 
              @click="handleDownload"
            >
              下载
            </a>
          </p>
          <p class="time-line">上次导出时间：{{ exportData.modifyDate }}</p>
        </div>
      </div>
    </div>
    
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleClose">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { downloadByUrl } from "@/utils/common.js";
export default {
  name: 'ExportResultModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    exportData: {
      type: Object,
      default: null
    }
  },
  computed: {
    hasExportData() {
      return this.exportData && Object.keys(this.exportData).length > 0;
    }
  },
  methods: {
    handleClose() {
      this.$emit('close');
    },
    handleDownload() {
      if (this.exportData && this.exportData.attachment) {
        downloadByUrl(this.exportData.fileName, this.exportData.attachment);
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.result-content {
  min-height: 80px;
}

.no-data-content {
  text-align: center;
  padding: 20px 0;
  
  .result-text {
    margin: 5px 0;
    font-size: 14px;
    color: #606266;
    line-height: 24px;
  }
}

.data-content {
  padding: 10px 0;
  
  .file-info {
    .file-line {
      font-size: 14px;
      color: #606266;
      line-height: 24px;
      margin-bottom: 10px;
    }
    
    .time-line {
      font-size: 14px;
      color: #606266;
      line-height: 24px;
    }
  }
}

.download-link {
  color: #409EFF;
  text-decoration: underline;
  margin-left: 10px;
  cursor: pointer;
  
  &:hover {
    color: #66b1ff;
  }
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  
  ::v-deep .el-button {
    padding: 9px 15px;
  }
}
</style>

<style lang="scss">
.export-result-dialog {
  .el-dialog__header {
    padding: 15px 20px;
    border-bottom: 1px solid #DCDFE6;
  }
  
  .el-dialog__body {
    padding: 20px;
  }
  
  .el-dialog__footer {
    padding: 15px 20px;
    border-top: 1px solid #DCDFE6;
  }
}
</style>